import angular from 'angular';
import { MovimentacoesQuickAddController } from './movimentacoes-quick-add.controller';

export class MovimentacoesQuickAddComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesQuickAdd';
    static controller = MovimentacoesQuickAddController;
    static template = require('!!html-loader!./movimentacoes-quick-add.component.html');
    static bindings = {
        selectedPeriod: '<',
        submitting: '<',
        onSubmit: '&',
        onClose: '&'
    };
}
